<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button @click="showAdd = true" class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>

                    <vs-button
                        @click="viewData"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="showFilter = true"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="printLabel"
                        icon="print"
                    >Print Label</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item
                                @click="exportExcel({ endpoint: 'master/packaging/report/exportexcel', name: 'packaging', filter: filter })"
                            >Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="multiple"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
        </vx-card>

        <vs-prompt title="Filter" :active.sync="showFilter" buttons-hidden>
            <div class="con-exemple-prompt">
                <vs-input v-model="filter.code" class="mb-2 w-full" label="Code" />
                <vs-input
                    v-model="filter.description"
                    class="mb-2 w-full"
                    label="Description"
                />
                <vs-input
                    v-model="filter.width"
                    type="number"
                    class="mb-2 w-full"
                    label="Width"
                />
                <vs-input
                    v-model="filter.length"
                    type="number"
                    class="mb-2 w-full"
                    label="Length"
                />
                <vs-input
                    v-model="filter.height"
                    type="number"
                    class="mb-2 w-full"
                    label="Height"
                />
                <vs-input
                    v-model="filter.weight"
                    type="number"
                    class="mb-2 w-full"
                    label="Weight"
                />
                <vs-row
                    vs-align="flex-start"
                    vs-type="flex"
                    vs-justify="flex-end"
                    vs-w="12"
                    class="mt-5"
                >
                    <vs-button color="primary" type="flat" class="mr-2" @click="resetFilter">Reset</vs-button>
                    <vs-button color="primary" @click="filterData">Search</vs-button>
                </vs-row>
            </div>
        </vs-prompt>

        <vs-prompt title="Add Packaging" :active.sync="showAdd" buttons-hidden >
            <div class="con-exemple-prompt">
                <vs-input v-model="add.code" class="mb-2 w-full" label="Code" />
                <vs-input v-model="add.description" class="mb-2 w-full" label="Description" />
                <vs-input v-model="add.width" type="number" class="mb-2 w-full" label="Width" />
                <vs-input
                    v-model="add.length"
                    type="number"
                    class="mb-2 w-full"
                    label="Length"
                />
                <vs-input
                    v-model="add.height"
                    type="number"
                    class="mb-2 w-full"
                    label="Height"
                />
                <vs-input
                    v-model="add.weight"
                    type="number"
                    class="mb-2 w-full"
                    label="Weight"
                />
                <vs-row
                    vs-align="flex-start"
                    vs-type="flex"
                    vs-justify="flex-end"
                    vs-w="12"
                    class="mt-5"
                >
                    <vs-button color="primary" @click="addData">Save</vs-button>
                </vs-row>
            </div>
        </vs-prompt>

        <vs-prompt buttons-hidden title="View" :active.sync="showEdit">
            <div class="con-exemple-prompt">
                <vs-input
                    v-model="edit.code"
                    class="mb-2 w-full"
                    label="Code"
                    :disabled="!isEdit"
                />
                <vs-input
                    v-model="edit.description"
                    class="mb-2 w-full"
                    label="Description"
                    :disabled="!isEdit"
                />
                <vs-input
                    v-model="edit.width"
                    type="number"
                    class="mb-2 w-full"
                    label="Width"
                    :disabled="!isEdit"
                />
                <vs-input
                    v-model="edit.length"
                    type="number"
                    class="mb-2 w-full"
                    label="Length"
                    :disabled="!isEdit"
                />
                <vs-input
                    v-model="edit.height"
                    type="number"
                    class="mb-2 w-full"
                    label="Height"
                    :disabled="!isEdit"
                />
                <vs-input
                    v-model="edit.weight"
                    type="number"
                    class="mb-2 w-full"
                    label="Weight"
                    :disabled="!isEdit"
                />
            </div>
            <vs-row
                vs-align="flex-start"
                vs-type="flex"
                vs-justify="flex-end"
                vs-w="12"
                class="mt-5"
            >
                <vs-button color="primary" class="mt-2 mr-2" @click="isEdit = true">Edit</vs-button>
                <vs-button
                    color="primary"
                    class="mt-2"
                    @click="saveDataEdit"
                    :disabled="!isEdit"
                >Save</vs-button>
            </vs-row>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { error } from "util";
import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            showFilter: false,
            showEdit: false,
            filter: {},
            edit: {},
            isEdit: false,
            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,

            // Add
            showAdd: false,
            add: {}
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        resetFilter() {
            this.filter = {}
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this Packaging?",
                accept: this.acceptAlert
            });
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete("master/packaging/" + this.selectedId + "/destroy")
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "section deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: res.data.message
                    });
                })
                .catch(error => {
                    this.$vs.notify({
                        title: "Error",
                        text: "Error.",
                        color: "danger"
                    });
                })
                .then(() => {
                    this.fetchData();
                });
        },
        refreshData() {
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post(
                    "master/packaging/filter/search?page=" + this.currentPage,
                    this.filter
                )
                .then(res => {
                    this.data = res.data.data;
                    this.totalPage = res.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = res.data.total;
                    this.dataFrom = res.data.from;
                    this.dataTo = res.data.to;
                    this.isLoading = false;
                })
                .catch(resp => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                    return;
                });
        },
        viewData() {
            this.isLoading = true;
            this.$http
                .get("master/packaging/" + this.selectedId)
                .then(res => {
                    this.edit = res.data;
                    this.isEdit = false
                })
                .catch(error => handleError(error))
                .then(() => {
                    this.isLoading = false;
                    this.showEdit = true;
                });
        },
        saveDataEdit() {
            this.isLoading = true;
            this.$http
                .put(
                    "master/packaging/" + this.selectedId + "/update",
                    this.edit
                )
                .then(res => {
                    this.isLoading = false;
                    this.isEdit = false;
                    this.showEdit = false;
                    this.selectedId = null;
                    this.fetchData();
                    const message = res.data.message
                        ? res.data.message
                        : "Success.";
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: message
                    });
                })
                .catch(error => this.handleError(error));
        },
        filterData() {
            this.showFilter = false;
            this.currentPage = 1;
            this.fetchData();
        },
        addData() {
            this.isLoading = true;
            this.$http
                .post("master/packaging/store", this.add)
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: res.data.message
                    });
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
                .then(() => {
                    this.isLoading = false;
                    this.fetchData();
                    this.add = {};
                });
        },
        printLabel() {
            this.isLoading = true;

            const id = this.gridApi.getSelectedRows().map(item => {
                return item.id;
            });

            this.$http
                .post(
                    "master/packaging/print_label",
                    { id: id },
                    { responseType: "blob" }
                )
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    window.open(URL.createObjectURL(blob));
                })
                .catch(error => console.log(error))
                .then(() => (this.isLoading = false));
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/packaging/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "packaging-upload-template.xlsx");
                });
        },
        uploadExcel() {
            let file = event.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/packaging/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Data Successfully"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Packaging ID",
                field: "id",
                // checkboxSelection: true,
                // headerCheckboxSelection: true,
                width: 120
            },
            {
                headerName: "Code",
                field: "code",
                width: 120
            },
            {
                headerName: "Description",
                field: "description",
                width: 120
            },
            {
                headerName: "Width",
                field: "width",
                width: 120
            },
            {
                headerName: "Length",
                field: "length",
                width: 120
            },
            {
                headerName: "Height",
                field: "height",
                width: 120
            },
            {
                headerName: "Weight",
                field: "weight",
                width: 120
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>